import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountIndividualsQueryKey } from "../account.keys";

export const useAdminFetchAccountIndividuals = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, isFetched, isFetching, refetch } = useQuery({
		queryKey: accountIndividualsQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.Admin.SuretyAccount.Get.Response.Individual[]>(
				`/v2/admin/surety/accounts/${accountId}/individuals`,
			),
		retry: false,
	});

	return {
		individuals: data,
		individualsError: error,
		individualsIsLoading: isLoading,
		individualsIsFetched: isFetched,
		individualsIsFetching: isFetching,
		refetchIndividuals: refetch,
	};
};
